import { Controller } from "@hotwired/stimulus"

// Stimulus controller for refreshing newsletter lists
export default class extends Controller {
  static values = { url: String }

  async refresh(event) {
    event.preventDefault()

    const button = event.currentTarget
    const originalText = button.innerHTML

    // Show loading state
    button.disabled = true
    button.innerHTML = `
      <svg class="animate-spin -ml-0.5 mr-1.5 h-4 w-4 inline" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Refreshing...
    `

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
          "Accept": "text/vnd.turbo-stream.html"
        }
      })

      if (response.ok) {
        // Turbo will handle the stream response automatically
        // Just restore the button
        setTimeout(() => {
          button.disabled = false
          button.innerHTML = originalText
        }, 500)
      } else {
        throw new Error("Failed to refresh lists")
      }
    } catch (error) {
      alert("Failed to refresh lists. Please try again.")
      button.disabled = false
      button.innerHTML = originalText
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
